import React, { createContext, useContext, useMemo } from 'react';
import { RowsContext } from './row-info';
import { ColumnsContext } from './column';
import { FilterContext } from './filter';
import { SortContext } from './sort';
import { ExpansionContext, TreeContext } from './active';
import { SelectionContext } from './selection';
import { PaginationContext } from './pagination';
var Context = createContext({
  original: [],
  current: [],
  columns: [],
  filterState: undefined,
  filterActions: undefined,
  sortState: undefined,
  sortActions: undefined,
  treeActive: undefined,
  treeActions: undefined,
  expansionActive: undefined,
  expansionActions: undefined,
  selected: undefined,
  selectionActions: undefined,
  paginationState: undefined,
  paginationActions: undefined
});
export var useTableContext = function useTableContext() {
  return useContext(Context);
};
export var TableContextProvider = function TableContextProvider(props) {
  var original = props.original,
      current = props.current,
      columns = props.columns,
      filterState = props.filterState,
      filterActions = props.filterActions,
      sortState = props.sortState,
      sortActions = props.sortActions,
      treeActive = props.treeActive,
      treeActions = props.treeActions,
      expansionActive = props.expansionActive,
      expansionActions = props.expansionActions,
      selected = props.selected,
      selectionActions = props.selectionActions,
      paginationState = props.paginationState,
      paginationActions = props.paginationActions,
      children = props.children;
  var tableContext = useMemo(function () {
    return {
      original: original,
      current: current,
      columns: columns,
      filterState: filterState,
      filterActions: filterActions,
      sortState: sortState,
      sortActions: sortActions,
      treeActive: treeActive,
      treeActions: treeActions,
      expansionActive: expansionActive,
      expansionActions: expansionActions,
      selected: selected,
      selectionActions: selectionActions,
      paginationState: paginationState,
      paginationActions: paginationActions
    };
  }, [original, current, columns, filterState, filterActions, sortState, sortActions, treeActive, treeActions, expansionActive, expansionActions, selected, selectionActions, paginationState, paginationActions]);
  var rowsContext = useMemo(function () {
    return {
      original: original,
      current: current
    };
  }, [original, current]);
  var columnsContext = useMemo(function () {
    return {
      columns: columns
    };
  }, [columns]);
  var treeContext = useMemo(function () {
    return {
      active: treeActive,
      actions: treeActions
    };
  }, [treeActive, treeActions]);
  var expansionContext = useMemo(function () {
    return {
      active: expansionActive,
      actions: expansionActions
    };
  }, [expansionActive, expansionActions]);
  var selectionContext = useMemo(function () {
    return {
      selected: selected,
      actions: selectionActions
    };
  }, [selected, selectionActions]);
  var filterContext = useMemo(function () {
    return {
      state: filterState,
      actions: filterActions
    };
  }, [filterState, filterActions]);
  var sortContext = useMemo(function () {
    return {
      state: sortState,
      actions: sortActions
    };
  }, [sortState, sortActions]);
  var paginationContext = useMemo(function () {
    return {
      state: paginationState,
      actions: paginationActions
    };
  }, [paginationState, paginationActions]);
  return React.createElement(Context.Provider, {
    value: tableContext
  }, React.createElement(RowsContext.Provider, {
    value: rowsContext
  }, React.createElement(ColumnsContext.Provider, {
    value: columnsContext
  }, React.createElement(TreeContext.Provider, {
    value: treeContext
  }, React.createElement(ExpansionContext.Provider, {
    value: expansionContext
  }, React.createElement(SelectionContext.Provider, {
    value: selectionContext
  }, React.createElement(FilterContext.Provider, {
    value: filterContext
  }, React.createElement(SortContext.Provider, {
    value: sortContext
  }, React.createElement(PaginationContext.Provider, {
    value: paginationContext
  }, children)))))))));
};